export enum PaginationType {
  CarouselDots = 'carousel_dots',
  DatasetNumbers = 'dataset_numbers',
}

export type PaginationProps = {
  /** Total number of pages/steps. */
  totalPages: number;
  /** Current active page (1-based). Defaults to 1. */
  currentPage?: number;
  /** Visual variant: carousel_dots for carousels, dataset_numbers for data tables/datasets. Nullable — when not set, only prev/next arrows are rendered. */
  type?: PaginationType;
  /** Disables all interaction. */
  disabled?: boolean;
  /** Accessible label for the navigation landmark. */
  ariaLabel?: string;
  /** Accessible label for the previous-page button. */
  prevAriaLabel?: string;
  /** Accessible label for the next-page button. */
  nextAriaLabel?: string;
  /** Root `data-testid`; defaults to `ds-pagination-{id}` from `useId()`. */
  testId?: string;
};
